import { createReducer, on } from '@ngrx/store';

import * as AppActions from './actions';
import { AppState } from '../shared/models/models';

export const initialState: AppState = {
  rationComponents: null,
};

export const appReducer = createReducer<AppState>(
  initialState,
  on(AppActions.loadRationComponentsSuccess, (state, { rationComponents }) => ({
    ...state,
    rationComponents,
  })),
);
